import { NEXT_ENTITY, QUERY_VARIANT } from '@common/interfaces/entity';
import { getCachedToken } from '@config/authentication';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '@store';
import { selectOrderId } from '@store/selectors';
import { setCustomer } from '@store/slices/customerSlice';
import { setOrder } from '@store/slices/orderSlice';
import { queryNextEntityWithToken } from '@utils/serverActions/clientUtility';
import { API_CACHE_POLICY } from 'types';

export const refetchOrder = createAsyncThunk(
  'refetchOrder',
  async (orderIdParam: string = null, { dispatch, getState, rejectWithValue }) => {
    const state = getState() as RootState;
    const orderId = selectOrderId(state);
    const variables = {
      id: orderIdParam || orderId,
    };
    try {
      const order = await queryNextEntityWithToken(
        NEXT_ENTITY.ORDER,
        getCachedToken(),
        variables,
        QUERY_VARIANT.CONCISED,
        { cache: API_CACHE_POLICY.NO_STORE },
        orderId
      );
      dispatch(setOrder(order));
      dispatch(setCustomer(order?.customer));
      if (order) {
        return true;
      } else {
        return rejectWithValue('OrderFetchFailed');
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
